<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <v-progress-linear
      v-if="mainPageLoading"
      indeterminate
    />
    <page-header class="py-4 pb-6">
      {{ entityName }}
      <template #action>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="showAddDialog=true"
        >
          {{ $t('NewAddImage') }}
        </v-btn>
      </template>
    </page-header>
    <v-btn
      v-if="sortChanged"
      class="mr-2"
      elevation="0"
      outlined
      style="background: white"
      @click="updateSort"
    >
      {{ $t('saveSort') }}
    </v-btn>
    <div class="my-4">
      {{ $t('dragToSort') }}
    </div>

    <draggable
      v-if="!refreshMarker"
      v-model="imageList"
      :style="!$vuetify.breakpoint.lgAndUp ? 'grid-template-columns: repeat(2,minmax(0,1fr));' :
        'grid-template-columns: repeat(6,minmax(0,1fr));'"
      style="display: grid;grid-gap: 12px"
    >
      <v-card
        v-for="item in imageList"
        :key="item.id"
        class="d-flex align-center justify-center"
        elevation="0"
        style="position: relative"
      >
        <div style="width: 100%">
          <v-img
            :src="imageRoot+item.image"
            height="180"
            style="border-radius: 12px"
            width="100%"
          >
            <template #placeholder>
              <v-card
                class="d-flex align-center justify-center"
                height="180"
              >
                <v-progress-circular />
              </v-card>
            </template>
          </v-img>
        </div>
        <v-btn
          color="white"
          icon
          small
          style="position: absolute;right: 4px;top: 4px;background: rgba(0,0,0,0.4);border-radius: 4px"
          @click="deleteItem(item)"
        >
          {{ item.id }}
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
    </draggable>
    <ik-entity-form
      v-model="showAddDialog"
      :edited-index="-1"
      :model="model"
      :title="$t('sub_screen_picture')"
      @need-refresh="reload"
    />
  </div>
</template>

<script>
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import draggable from 'vuedraggable'
import IKUtils from 'innerken-js-utils'
import { showSuccessMessage, sureToDelete } from '@/model/utils/utils'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'

export default {
  name: 'ImageList',
  components: {

    PageHeader,
    draggable,
    IkEntityForm

  },
  props: {
    model: {},
    desc: {},
    entityName: {}
  },
  data: function () {
    return {
      mainPageLoading: false,
      imageList: [],
      originImageList: [],
      refreshMarker: false,
      showAddDialog: false

    }
  },
  computed: {
    imageRoot () {
      return this.model.entity.image.formConfig.type.root()
    },
    sortChanged () {
      const originSort = this.originImageList.map(it => it.id).join('')
      return originSort !== this.imageList.map(it => it.id).join('')
    }
  },
  watch: {
    imageList (val) {
      setTimeout(() => {
        this.refreshMarker = true
        setTimeout(() => {
          this.refreshMarker = false
        }, 10)
      }, 20)
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async reload () {
      this.mainPageLoading = true
      this.originImageList = await this.model.getList(true)
      this.imageList = this.originImageList
      this.mainPageLoading = false
    },

    async updateSort () {
      IKUtils.showLoading()
      const reqs = this.imageList.map(async (it, i) => {
        it.sort = i + 1
        return await this.model.edit(it, false)
      })
      await Promise.allSettled(reqs)
      await this.reload()
      showSuccessMessage()
    },
    async deleteItem (item, promt = true) {
      await sureToDelete(async () => {
        await IKUtils.safeCallFunction(this.model, this.model.remove, item.id)
        showSuccessMessage(this.$t('delete_success'))
        await this.reload()
      })
    }
  }
}
</script>

<style scoped>

</style>
